/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePublicDraftInstantConversationRequest
 */
export interface CreatePublicDraftInstantConversationRequest {
    /**
     * The accountId of the freelancer
     * @type {string}
     * @memberof CreatePublicDraftInstantConversationRequest
     */
    freelancerAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicDraftInstantConversationRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicDraftInstantConversationRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicDraftInstantConversationRequest
     */
    searchEventId?: string;
}

/**
 * Check if a given object implements the CreatePublicDraftInstantConversationRequest interface.
 */
export function instanceOfCreatePublicDraftInstantConversationRequest(value: object): value is CreatePublicDraftInstantConversationRequest {
    if (!('freelancerAccountId' in value) || value['freelancerAccountId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function CreatePublicDraftInstantConversationRequestFromJSON(json: any): CreatePublicDraftInstantConversationRequest {
    return CreatePublicDraftInstantConversationRequestFromJSONTyped(json, false);
}

export function CreatePublicDraftInstantConversationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePublicDraftInstantConversationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerAccountId': json['freelancerAccountId'],
        'content': json['content'],
        'subject': json['subject'],
        'searchEventId': json['searchEventId'] == null ? undefined : json['searchEventId'],
    };
}

export function CreatePublicDraftInstantConversationRequestToJSON(value?: CreatePublicDraftInstantConversationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerAccountId': value['freelancerAccountId'],
        'content': value['content'],
        'subject': value['subject'],
        'searchEventId': value['searchEventId'],
    };
}

